import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePrizeEmailConfirmationStore = defineStore('prizeEmailConfirmation', () => {
  const open = ref(false)
  const emailAddress = ref('')
  const keepsPaidItem = ref(false)
  const focusEmail = ref(0)
  let resolve: ((accepted: boolean) => void) | null = null
  let editOnClose = false

  function finish(accepted: boolean, editEmail = false) {
    if (!open.value)
      return
    open.value = false
    editOnClose = editEmail
    resolve?.(accepted)
    resolve = null
  }

  function restoreFocus(event: Event) {
    if (editOnClose) {
      event.preventDefault()
      editOnClose = false
      focusEmail.value++
    }
  }

  function request(email: string, keepItem: boolean) {
    finish(false)
    emailAddress.value = email
    keepsPaidItem.value = keepItem
    open.value = true
    return new Promise<boolean>((done) => {
      resolve = done
    })
  }

  return { open, emailAddress, keepsPaidItem, focusEmail, request, finish, restoreFocus }
})
